import { render, staticRenderFns } from "./idleHome.vue?vue&type=template&id=62316f9e&"
import script from "./idleHome.vue?vue&type=script&lang=js&"
export * from "./idleHome.vue?vue&type=script&lang=js&"
import style0 from "./idleHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports